import { render, staticRenderFns } from "./activityCenterList.vue?vue&type=template&id=2b856489&scoped=true&"
import script from "./activityCenterList.vue?vue&type=script&lang=js&"
export * from "./activityCenterList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b856489",
  null
  
)

export default component.exports